import React from 'react'
// constants
import { Modals } from 'constants/index'
// components
import { Modal } from 'components/UI'
import ScaleOptionForm from 'components/Modals/ScaleOptionModal/Form'
// hooks
import { useModalData } from 'hooks/index'
// views
import { Header } from 'components/Modals/ScaleOptionModal/Create'
// themes
import { CloseIcon } from 'components/UI/Icons'

const PAPER_PROPS = {
  style: {
    padding: '16px'
  }
}

const ScaleOptionEditModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, option, editOption }
  } = useModalData({ modalType: Modals.SCALE_OPTION_EDIT_MODAL })

  if (!option) {
    return null
  }

  const handleSubmit = async (data) => {
    await editOption({ ...data, id: option.id })
    hideModal()
  }

  const initialValues = {
    active: option.active,
    label: option.label,
    value: option.value
  }

  return (
    <Modal
      width={'xs'}
      hideBackdrop
      isOpen={isOpen}
      disableRestoreFocus
      disableBackdropClick
      disableEscapeKeyDown
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}>
      <Header>
        <span>Edit Scale Option</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <ScaleOptionForm initialValues={initialValues} isEdit onSubmit={handleSubmit} hideModal={hideModal} />
    </Modal>
  )
}

export default ScaleOptionEditModal
